import { render, staticRenderFns } from "./AddressEdit.vue?vue&type=template&id=5d3cd5f4&scoped=true"
import script from "./AddressEdit.vue?vue&type=script&lang=js"
export * from "./AddressEdit.vue?vue&type=script&lang=js"
import style0 from "./AddressEdit.vue?vue&type=style&index=0&id=5d3cd5f4&prod&scoped=true&lang=scss"
import style1 from "./AddressEdit.vue?vue&type=style&index=1&id=5d3cd5f4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d3cd5f4",
  null
  
)

export default component.exports